import { featuredArticle, focusArticles } from "@/mocks/media";

export default function Focus() {
  const f = featuredArticle;

  return (
    <section id="focus" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-primary-500" />
              <span className="text-xs font-medium uppercase tracking-[0.25em] text-primary-500">
                FOCUS ARCHIVE
              </span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              本期焦点档案
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              近期最值得慢读的一篇头条，与三篇快速了解议题的全景短文。
            </p>
          </div>
          <a
            href="#reading"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            进入全部解读
            <i className="ri-arrow-right-line text-sm" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <a
            href="#reading"
            className="group relative flex flex-col overflow-hidden rounded-lg bg-foreground-950 lg:col-span-2"
          >
            <div className="relative h-64 overflow-hidden sm:h-80 lg:h-[440px]">
              <img
                src={f.image}
                alt={f.alt}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/20 to-transparent" />
              <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                {f.category} · {f.kind}
              </span>
            </div>
            <div className="flex flex-1 flex-col justify-end bg-foreground-950 p-5 md:p-8">
              <p className="text-xs uppercase tracking-[0.2em] text-accent-400">{f.tag} / HEADLINE</p>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-white md:text-3xl">
                {f.title}
              </h3>
              <p className="mt-3 line-clamp-2 text-sm leading-7 text-foreground-300">{f.standfirst}</p>
              <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-400">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line" />
                  {f.author}
                </span>
                <span>{f.role}</span>
                <span>发布于 {f.date}</span>
                <span>约 {f.readTime}</span>
              </div>
            </div>
          </a>

          <div className="flex flex-col gap-4">
            {focusArticles.map((item) => (
              <a
                key={item.id}
                href="#reading"
                className="group flex flex-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100"
              >
                <div className="flex-1">
                  <span className="inline-flex rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                    {item.category}
                  </span>
                  <h4 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                    {item.title}
                  </h4>
                  <p className="mt-2 hidden text-xs text-foreground-600 sm:line-clamp-2 sm:block">
                    {item.standfirst}
                  </p>
                  <div className="mt-2 flex items-center gap-3 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" />
                      {item.readTime}
                    </span>
                    <span>{item.date}</span>
                  </div>
                </div>
                <div className="hidden w-[92px] shrink-0 overflow-hidden rounded-md sm:block">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="h-20 w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
              </a>
            ))}
            <div className="rounded-lg border border-dashed border-background-300 bg-background-100/60 px-4 py-3 text-xs leading-6 text-foreground-500">
              以上为编辑部提炼的开篇，完整拆解与更多案例见下方
              <a href="#reading" className="mx-1 font-medium text-primary-600 hover:underline">
                深度解读
              </a>
              板块。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}